module.exports = __webpack_public_path__ + "img/vue2-languette_rouge.f3ebd6de.png";